import styled from "styled-components";

const ListItem = styled.li`
  position: relative;
  padding: 0 0.75rem;
  margin: 0;

  &:last-child {
    padding-right: 0;
  }

  &:last-child > a::after {
    display: none;
  }
`;

export default ListItem;
